import { createPortal } from "react-dom"
import { toast } from "react-toastify"
import classNames from "classnames"

import { useLazyUpdateWHDevicesStatusQuery } from "store/api/warehouseManagerApi"
import { useAppSelector } from "store/hooks"
import styles from "assets/scss/index.module.scss"
import { ReactComponent as IconMissing } from "assets/svg/modal-icon-missing.svg"

import getErrorMessage from "utils/getErrorMessage"
import { ModalLayout } from "layouts/ModalLayout"

interface Props {
  onCancel: () => void
  onSuccess: () => void
}

export const MissingModalWarehouse = ({ onCancel, onSuccess }: Props) => {
  const [triggerUpdateWHDevices, { isFetching }] = useLazyUpdateWHDevicesStatusQuery()
  const selectedDeviceIDs = useAppSelector(state => state.tempData.selectedDeviceIDs)

  const onSubmit = async (event: React.FormEvent) => {
    event.preventDefault()

    try {
      const res = await triggerUpdateWHDevices({
        device_ids: selectedDeviceIDs,
        phisical_status: "missing",
      })
      const error = getErrorMessage(res?.error)

      if (error) {
        toast.error(error)
      } else {
        toast.success("The status of the selected device(s) was changed successfully!")
        onSuccess()
      }
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <>
      {createPortal(
        <ModalLayout width="450px" isFetching={isFetching} onConfirm={onSubmit} onCancel={onCancel}>
          <div className={classNames(styles.modalContent, styles.center)}>
            <IconMissing />
            <h3 className={styles.modalTitle}>Mark as missing</h3>
            <div className={styles.modalMessage}>
              By changing the status of the selected device(s) to “Missing”, you confirm that these device(s) are no
              longer in your Stock. Are you sure you want to change the status of the selected device(s)?
            </div>
          </div>
        </ModalLayout>,
        document.body,
      )}
    </>
  )
}
